import {useMutation, useQuery} from '@tanstack/react-query';
import {
  getProjectFieldList,
  ProjectFieldListResponse,
  GetProjectFieldListRequestParams,
  updateProjectFieldState,
  ProjectField,
} from '../../api/endpoints/projectApi';

export const useProjectFieldList = (
  payload: GetProjectFieldListRequestParams
) => {
  return useQuery<ProjectFieldListResponse, Error>({
    queryKey: ['projectFieldList', payload],
    queryFn: () => getProjectFieldList(payload),
  });
};

export const useUpdateProjectActivationState = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation({
    mutationFn: (projectField: ProjectField) =>
      updateProjectFieldState(projectField),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
